import { useContext } from 'react';
import { UserContext } from '@namespace/user';

export const useIsCurrencyUahAndNotVipUser = () => {
  const [user] = useContext(UserContext);
  const { isVipUser = false, activeWallet = {}, defaultCurrency = '' } = user;
  const { currency = '' } = activeWallet;
  const userCurrency = (currency || defaultCurrency).toUpperCase();

  return !isVipUser && userCurrency === 'UAH';
};
